import { Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
import ImportProgress from '../records/ImportProgressRecord';
import { hasCancelledImporting as getHasCancelledImporting, hasSuccessfullyCompletedImporting as getHasSuccessfullyCompletedImporting, isImporting as getIsImporting, isLocked as getIsLocked, isPostProcessing as getIsPostProcessing, isScraping as getIsScraping } from '../utils/importProgressUtils';
export default function importArticlesProgress(state = ImmutableMap(), {
  error,
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_IMPORT_PROGRESS_PENDING:
      {
        const {
          knowledgeBaseId
        } = payload;
        return state.updateIn([knowledgeBaseId], (progress = ImportProgress()) => progress.set('isRequesting', true));
      }
    case ActionTypes.FETCH_IMPORT_PROGRESS_SUCCESS:
      {
        const {
          knowledgeBaseId
        } = payload;
        const importProgress = state.get(knowledgeBaseId) || new ImportProgress();
        const wasPollingActive = importProgress.isScraping || importProgress.isImporting || importProgress.isPostProcessing || importProgress.isPollingActive;
        const hasCancelledImporting = wasPollingActive && getHasCancelledImporting(payload);
        const hasSuccessfullyCompletedImporting = wasPollingActive && getHasSuccessfullyCompletedImporting(payload);
        const isImporting = getIsImporting(payload);
        const isPostProcessing = getIsPostProcessing(payload);
        const isScraping = getIsScraping(payload);
        const isLocked = getIsLocked(payload);
        const isPollingActive = (wasPollingActive || isImporting || isScraping || isPostProcessing) && isLocked;
        return state.mergeIn([knowledgeBaseId], Object.assign({}, payload, {
          hasCancelledImporting,
          hasSuccessfullyCompletedImporting,
          isImporting,
          isPollingActive,
          isPostProcessing,
          isRequesting: false,
          isScraping,
          lastLoaded: new Date().valueOf()
        }));
      }
    case ActionTypes.FETCH_IMPORT_PROGRESS_ERROR:
      {
        const {
          knowledgeBaseId
        } = payload;
        return state.updateIn([knowledgeBaseId], importProgress => importProgress.merge({
          error,
          isImporting: false,
          isRequesting: false,
          isPollingActive: false,
          isPostProcessing: false,
          isScraping: false
        }));
      }
    case ActionTypes.START_IMPORT_SUCCESS:
      return state.set(payload.knowledgeBaseId, new ImportProgress({
        isPollingActive: true,
        isScraping: true
      }));
    default:
      return state;
  }
}